import React from "react";
import About from "../components/About";
import Guides from "../components/Guides";
import SEO from "../components/SEO";
import { useSettings } from "../lib/settings";

const AboutPage = () => {
  const { settings } = useSettings();
  return (
    <div>
      <SEO
        title={`About · ${settings?.seo_org_name || "Free Istanbul Tours"}`}
        description="Meet the licensed local guides behind Free Istanbul Tours. Learn our story, values, and the neighbourhoods we call home."
        path="/about"
      />
      <div className="pt-16">
        <About headingLevel="h1" />
      </div>
      <Guides />
    </div>
  );
};

export default AboutPage;
